export enum ContentType {
  NewsPost = "NEWS_POST",
  EventPost = "EVENT_POST",
  BuildingInfoPost = "BUILDING_INFO_POST",
}
